import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionRoute = ({ children, permissionKey }) => {
  const { permissions, role } = useSelector((state) => state.auth);

  if (role?.toLowerCase() === "admin") {
    return children;
  }

  if (!permissionKey) {
    return children;
  }

  if (permissions?.[permissionKey] === 1) {
    return children;
  }

  // return <Navigate to="/" replace />;
   return (
    <Navigate
      to={permissions?.dashboard === 1 ? "/" : "/"}
      replace
    />
  );
};

export default PermissionRoute;